<template>
  <div class="question-list w-100 h-100" @click="questionDivClick($event)">
    <div
      :title="translate('question_component_button_add_question')"
      class="btn btn-icon btn-white w-40px h-40px pulse pulse-dark shadow-sm position-fixed top-50 mt-10 end-0 transform-90 rounded-0 rounded-bottom"
      style="z-index: 5 !important"
      @click="addQuestion"
    >
      <span class="svg-icon svg-icon-3">
        <inline-svg src="media/icons/duotune/arrows/arr075.svg" />
      </span>
      <span class="pulse-ring"></span>
    </div>

    <div class="card">
      <div
        class="row d-flex justify-content-between align-items-center border-bottom p-5"
      >
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="ms-2 text-gray-800 m-0">
            {{ translate("question_component_page_title_h4") }}
            <i
              class="fas fa-exclamation-circle ms-1 fs-3"
              @click="description = !description"
              style="cursor: pointer"
            ></i>
          </h4>
          <div
            class="btn btn-icon btn-sm btn-active-light border"
            :title="translate('question_component_button_backto_list')"
            @click="router.push({ name: 'admin-template-questions-list' })"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/arrows/arr077.svg" />
            </span>
          </div>
        </div>
        <transition name="component-fade" mode="out-in">
          <div
            v-if="description"
            class="d-flex justify-content-start align-items-center"
          >
            <p class="text-gray-600 p-5 pb-0">
              {{ translate("question_component_description") }}
            </p>
          </div>
        </transition>
        <div class="d-flex justify-content-end w-100 mt-5">
          <div>
            <button
              v-if="howTemplate"
              class="btn btn-white btn-sm border border-gray-300 text-gray-800 position-relative me-2"
              @click="listActive = true"
            >
              {{ translate("question_comp_input_btn_select_template") }}
            </button>
            <button
              class="btn btn-white btn-sm border border-gray-300 text-gray-800 position-relative me-2"
              @click="addQuestion"
            >
              {{ translate("question_component_button_add_question") }}
            </button>
            <button
              class="btn btn-white btn-sm border border-gray-300 text-gray-800 position-relative"
              :disabled="checkedQuestionCount === 0 ? true : false"
              @click="postQuestionList"
            >
              <div
                v-if="loading"
                class="spinner-border spinner-border-sm mx-2"
              ></div>
              <span class="indicator-label">
                {{ translate("question_component_button_questions_save") }}
              </span>

              <span
                v-show="checkedQuestionCount > 0"
                class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-primary"
                >{{ checkedQuestionCount }}</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>

    <ConfirmPopup></ConfirmPopup>
    <ConfirmDialog group="exitPage"></ConfirmDialog>
    <!-- Question Item Start -->
    <transition-group name="component-fade" mode="out-in" tag="div">
      <div v-for="(question, index) in questionList" :key="question.id">
        <!-- Question Confirm True -->

        <div
          v-if="question.checked"
          class="card p-4 ps-8 pe-0 mt-4 position-relative justify-content-center"
          style="height: 60px"
        >
          <div class="row">
            <div class="confim-div">
              <a> {{ index + 1 }} </a>
            </div>

            <div class="row align-items-center">
              <div
                class="col-lg-9 overflow-hidden fw-bold text-gray-800"
                style="max-height: 39px !important"
              >
                {{ question.questionText }}
              </div>
              <div class="col-lg-3 align-items-center">
                <div class="d-flex justify-content-end">
                  <a
                    class="btn btn-icon btn-bg-white border btn-active-color-primary btn-sm me-1"
                    :title="translate('Edit')"
                    @click="question.checked = false"
                  >
                    <span class="svg-icon svg-icon-3">
                      <inline-svg src="media/icons/duotune/art/art005.svg" />
                    </span>
                  </a>
                  <a
                    class="btn btn-icon btn-bg-white border btn-active-color-danger btn-sm"
                    :title="translate('Delete')"
                    @click="deleteQuestion($event, question.id)"
                  >
                    <span class="svg-icon svg-icon-3">
                      <inline-svg
                        src="media/icons/duotune/general/gen027.svg"
                      />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Question Confirm False -->
        <div v-else class="card p-4 ps-0 pe-0 mt-4 position-relative">
          <div
            class="d-flex justify-content-between align-items-center border-bottom p-5 pt-3"
          >
            <div class="d-flex justify-content-start align-items-center w-100">
              <div class="ques-index-div">
                <a> {{ index + 1 }} </a>
              </div>
              <h5
                class="ms-2 text-gray-800 m-0 d-flex justify-content-between align-items-center w-100"
              >
                {{ translate("question_component_h3_content_title") }}

                <a
                  class="btn btn-sm btn-link btn-color-info btn-active-color-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#add-template-modal"
                  @click="selectTemplate(question)"
                  >{{ translate("question_comp_input_btn_save_template") }}</a
                >
              </h5>
            </div>
          </div>

          <!-- Question Type Checkbox / Is Required  Checkbox-->
          <div class="d-flex justify-content-end mt-6 px-5 py-1 gap-2">
            <div
              class="form-check form-check-custom form-check-solid pe-2 border border-2 border-top-0 border-bottom-0 border-start-0"
              :title="translate('question_component_checkbox_required_title')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :id="'isRequired-' + question.id"
                v-model.trim="question.isRequired"
              />
              <label
                class="form-check-label user-select-none text-gray-800 fw-bold"
                :for="'isRequired-' + question.id"
              >
                {{ translate("question_component_checkbox_required") }}
              </label>
            </div>
            <div class="form-check form-check-custom form-check-solid">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'check-' + question.id"
                v-model.trim="question.infoOnly"
                @change="changeQuestionInfoStatus($event, question)"
              />
              <label
                class="form-check-label user-select-none text-gray-800 fw-bold"
                :for="'check-' + question.id"
              >
                {{ translate("question_component_checkbox_label_info") }}
                <i
                  class="fas fa-exclamation-circle ms-1 fs-7"
                  :title="
                    translate(
                      'question_component_checkbox_label_info_icon_title'
                    )
                  "
                ></i>
              </label>
            </div>
          </div>
          <Form
            v-slot="{ errors }"
            class="form p-5 pb-2 rounded-bottom"
            novalidate="novalidate"
            @submit="confirmQuestion(question)"
            :validation-schema="questionValidator"
          >
            <!-- Questions Elements Start-->

            <!-- Question Categorys -->
            <div v-show="!question.infoOnly" class="row mt-2">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("question_component_input_categoryId")
              }}</label>
              <div class="col-lg-8 fv-row d-v-container">
                <Dropdown
                  class="mb-3"
                  :filter="!platform"
                  :emptyFilterMessage="translate('No_Records')"
                  v-model="question.categoryId"
                  :options="categoryList"
                  optionLabel="Value"
                  optionValue="Id"
                  :placeholder="
                    translate('question_component_input_select_category')
                  "
                  style="padding: 3px !important"
                  appendTo="self"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span
                        class="p-dropdown-trigger-icon pi pi-chevron-down"
                      ></span>
                    </div>

                    <i
                      v-if="question.categoryId === 0 ? false : true"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="question.categoryId = 0"
                    ></i>
                  </template>
                </Dropdown>
              </div>
            </div>
            <!-- Question Text  -->
            <div class="row mt-2">
              <label class="col-lg-4 col-form-label fw-bold fs-6 required">{{
                translate("question_component_input_title")
              }}</label>

              <div class="col-lg-8 fv-row d-v-container">
                <div class="fv-plugins-message-container d-v-s-content">
                  <div class="fv-help-block ms-2 v-element">
                    <ErrorMessage name="title" />
                  </div>
                </div>
                <Field
                  type="text"
                  name="title"
                  class="form-control fs-6"
                  :class="errors['title'] !== undefined ? 'v-invalid' : ''"
                  :placeholder="translate('question_component_input_title')"
                  v-model.trim="question.questionText"
                />
              </div>
            </div>
            <!--  Qustion İnfo Text -->
            <div class="row mt-5">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("question_component_input_info")
              }}</label>
              <div class="col-lg-8">
                <textarea
                  name="info"
                  v-model.trim="question.questionInfoText"
                  :placeholder="translate('question_component_input_info')"
                  class="form-control fs-6"
                />
              </div>
            </div>
            <!-- Question Code / Qusetion Score -->
            <div class="row mt-5">
              <label class="col-lg-4 col-form-label fw-bold fs-6"
                ><span>
                  {{ translate("question_component_input_code") }}
                </span>

                <span v-show="!question.infoOnly">
                  / {{ translate("question_component_input_score") }}
                </span>
              </label>
              <!-- Question Code -->
              <div class="col-lg-4 mb-5">
                <input
                  type="text"
                  name="code"
                  v-model.trim="question.code"
                  :placeholder="translate('question_component_input_code')"
                  class="form-control fs-6"
                />
              </div>

              <!-- Qusetion Score -->
              <div v-show="!question.infoOnly" class="col-lg-4 fv-row mb-5">
                <input
                  :disabled="answerTypeController(question.answers)"
                  type="number"
                  min="0"
                  name="questionScore"
                  onkeydown="return event.keyCode !== 69"
                  @blur="
                    question.score < 0 ? (question.score = 0) : question.score
                  "
                  :class="
                    errors['questionScore'] !== undefined ? 'v-invalid' : ''
                  "
                  v-model.number="question.score"
                  :placeholder="translate('question_component_input_score')"
                  class="form-control fs-6"
                />
              </div>
            </div>

            <!-- Question Answer Templete  -->
            <div v-show="!question.infoOnly" class="row mb-5">
              <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                translate("question_component_answer_template")
              }}</label>
              <div class="col-lg-8">
                <div class="d-flex align-items-center">
                  <MultiSelect
                    v-model="dynamicAnswerTemplateList[`list${question.id}`]"
                    :options="answersTemplates"
                    optionLabel="answerText"
                    :placeholder="
                      translate('question_component_answer_template_select')
                    "
                    style="padding: 3px !important"
                    :disabled="answerTypeController(question.answers)"
                  >
                  </MultiSelect>
                  <a
                    :class="
                      answerTypeController(question.answers) ? 'disabled' : ''
                    "
                    class="btn btn-sm btn-success ms-2"
                    @click="addAnswerTemplate(question)"
                    >{{ translate("Add") }}</a
                  >
                </div>
              </div>
            </div>

            <!-- Select Answer Type and Answers -->
            <div class="row mb-8 mt-10 position-relative">
              <!-- Answer Type List  -->
              <div class="col-lg-4">
                <a
                  :id="`btn-answer-list-${question.id}`"
                  class="btn btn-sm btn-success"
                  :class="
                    answerTypeController(question.answers) ? 'disabled' : ''
                  "
                  @click="answerMenuShow(question.id)"
                  >{{ translate("question_component_button_add_answer") }}</a
                >
                <ul
                  v-show="lastMenuId === question.id"
                  :id="`answer-list-${question.id}`"
                  class="answer-list"
                >
                  <div
                    v-for="(answerOption, index) in answerOptions"
                    :key="index"
                  >
                    <li
                      v-if="question.infoOnly"
                      @click="addAnswer(answerOption.type, question)"
                    >
                      <i
                        :class="answerOption.icon"
                        class="me-3 fs-5"
                        :style="`color:${answerOption.color}`"
                      ></i>
                      <span>
                        {{
                          translate(
                            `question_component_li_answer_type_${answerOption.type}`
                          )
                        }}
                      </span>
                    </li>
                    <li
                      v-else-if="
                        answerOption.type !== 'Single' &&
                        answerOption.type !== 'Radio' &&
                        answerOption.type !== 'Multiple'
                      "
                      :style="
                        index === 3
                          ? 'border-top: none; border-radius: 5px 5px 0 0;'
                          : ''
                      "
                      @click="addAnswer(answerOption.type, question)"
                    >
                      <i
                        :class="answerOption.icon"
                        class="me-3 fs-5"
                        :style="`color:${answerOption.color}`"
                      ></i>
                      <span>
                        {{
                          translate(
                            `question_component_li_answer_type_${answerOption.type}`
                          )
                        }}
                      </span>
                    </li>
                  </div>
                </ul>
              </div>
              <!-- Answer Type List  End-->

              <!-- Answer Buttons -->
              <div class="col-lg-8">
                <label
                  v-if="controlerAnswerFound(question.id)"
                  class="ms-3 fs-8"
                  style="color: #f31f0cd5"
                  >{{
                    translate("question_component_answer_select_valid")
                  }}</label
                >
                <div class="d-flex flex-wrap gap-10">
                  <div
                    class="d-inline"
                    v-for="(answer, inx) in question.answers"
                    :key="answer.id"
                  >
                    <Form
                      v-slot="{ errors }"
                      class="form p-0 m-0"
                      novalidate="novalidate"
                      @submit="saveAnswer(question, answer)"
                      :validation-schema="answerValidator"
                    >
                      <!-- Answer Buttons Start -->
                      <div
                        :id="`btn-answer-${answer.id}`"
                        :class="` position-relative
                          btn
                          btn-sm
                          btn-outline
                          btn-outline-dashed
    ${
      answer.answerText === ''
        ? 'btn-outline-danger btn-active-light-danger'
        : 'btn-outline-primary btn-active-light-primary'
    }`"
                      >
                        <span
                          v-if="!answerTypeController2(answer.type)"
                          class="ps-4 pe-4"
                        >
                          {{
                            answer.answerText === null ||
                            answer.answerText === ""
                              ? `${translate(
                                  "question_component_button_answer"
                                )} - ${inx + 1}`
                              : answer.answerText
                          }}
                        </span>
                        <div
                          v-else
                          class="d-flex align-items-center ps-4 pe-4 fs-6"
                        >
                          <i
                            v-if="answer.type === 'Text'"
                            class="bi bi-fonts me-1"
                            style="color: #214cc5"
                          ></i>
                          <i
                            v-if="answer.type === 'DateTime'"
                            class="bi bi-calendar me-1"
                            style="color: #214cc5"
                          ></i>
                          <i
                            v-if="answer.type === 'Phone'"
                            class="bi bi-telephone me-1"
                            style="color: #214cc5"
                          ></i>
                          <i
                            v-if="answer.type === 'Signature'"
                            class="bi bi-pencil-square me-1"
                            style="color: #214cc5"
                          ></i>
                          <i
                            v-if="answer.type === 'Location'"
                            class="bi bi-geo-alt me-1"
                            style="color: #214cc5"
                          ></i>

                          <span>
                            {{
                              translate(
                                `question_component_li_answer_type_${answer.type}`
                              )
                            }}
                          </span>
                        </div>

                        <span
                          data-bs-toggle="modal"
                          :data-bs-target="`#answer-modal-${answer.id}`"
                          @click="addEventModal(answer)"
                          class="position-absolute top-0 start-100 translate-middle badge badge-primary rounded-circle p-2 border shadow-sm"
                          ><i class="bi bi-pencil-fill fs-5 p-0 text-white"></i
                        ></span>

                        <span
                          class="position-absolute top-100 start-100 translate-middle badge badge-primary rounded-circle p-2 border shadow-sm"
                          @click="deleteAnswer(answer.id, question)"
                        >
                          <i class="bi bi-x-lg fs-6 p-0 text-white"></i
                        ></span>
                      </div>
                      <!-- Answer Buttons End -->

                      <!-- Answer Modal -->

                      <!-- İf Answer Type not Input -->
                      <div
                        v-if="!answerTypeController2(answer.type)"
                        class="modal fade"
                        tabindex="-1"
                        :id="`answer-modal-${answer.id}`"
                        ref="newTargetModalRef"
                        aria-hidden="true"
                      >
                        <div
                          class="modal-dialog modal-dialog-centered mw-750px"
                        >
                          <div class="modal-content rounded">
                            <!-- Answer Modal Header -->
                            <div class="modal-header">
                              <h5 class="modal-title">
                                {{
                                  translate(
                                    "question_component_modal_h5_content_title"
                                  )
                                }}
                              </h5>

                              <!--begin::Close-->
                              <div
                                class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
                                @click="closeModal"
                                aria-label="Close"
                              >
                                <i class="bi bi-x-lg"></i>
                              </div>
                              <!--end::Close-->
                            </div>

                            <!-- Answer Modal Body -->
                            <div class="modal-body rounded">
                              <!-- Answer Text -->
                              <div class="row mt-2">
                                <label
                                  class="col-lg-4 col-form-label fw-bold fs-6 required"
                                  >{{
                                    translate(
                                      "question_component_modal_label_answer_title"
                                    )
                                  }}</label
                                >

                                <div class="col-lg-8 fv-row d-v-container">
                                  <div
                                    class="fv-plugins-message-container d-v-s-content"
                                  >
                                    <div class="fv-help-block ms-2 v-element">
                                      <ErrorMessage name="answerTitle" />
                                    </div>
                                  </div>
                                  <Field
                                    :disabled="
                                      answer.answerTemplateId > 0 ? true : false
                                    "
                                    type="text"
                                    name="answerTitle"
                                    class="form-control fs-6"
                                    :class="
                                      errors['answerTitle'] !== undefined
                                        ? 'v-invalid'
                                        : ''
                                    "
                                    :placeholder="
                                      translate(
                                        'question_component_modal_label_answer_title'
                                      )
                                    "
                                    v-model.trim="answer.answerText"
                                  />
                                </div>
                              </div>

                              <!-- Answer Score / Answer View Order -->
                              <div class="row mt-2">
                                <label
                                  class="col-lg-4 col-form-label fw-bold fs-6"
                                >
                                  <span
                                    v-show="
                                      !answer.notScorable && !question.infoOnly
                                    "
                                    >{{
                                      translate(
                                        "question_component_modal_label_answer_score"
                                      )
                                    }}
                                    /
                                  </span>

                                  <span>
                                    {{
                                      translate(
                                        "question_component_modal_label_answer_orderBy"
                                      )
                                    }}
                                  </span></label
                                >
                                <!-- Answer Score -->
                                <div
                                  class="col-lg-4 mb-4"
                                  v-show="
                                    !answer.notScorable && !question.infoOnly
                                  "
                                >
                                  <div class="d-flex align-items-center">
                                    <input
                                      type="number"
                                      name="code"
                                      onkeydown="return event.keyCode !== 69"
                                      :max="question.score"
                                      @blur="
                                        answer.score > question.score
                                          ? (answer.score = question.score)
                                          : null
                                      "
                                      v-model.number="answer.score"
                                      :placeholder="
                                        translate(
                                          'question_component_modal_label_answer_score'
                                        )
                                      "
                                      :class="`form-control  fs-6 ${
                                        answer.score > question.score
                                          ? 'v-invalid'
                                          : ''
                                      }`"
                                    />

                                    <label
                                      v-show="answer.score > question.score"
                                      class="ms-3 fs-8"
                                      style="color: #f31f0cd5"
                                      >{{
                                        translate(
                                          "question_component_answer_modal_score_valid"
                                        )
                                      }}</label
                                    >
                                  </div>
                                </div>
                                <!-- Answer View Order  -->
                                <div class="col-lg-4 mb-4">
                                  <select
                                    :placeholder="
                                      translate(
                                        'question_component_modal_label_answer_orderBy'
                                      )
                                    "
                                    class="form-select fs-6"
                                    v-model.number="answer.displayOrder"
                                    @change="displayChange(question, answer)"
                                  >
                                    <option
                                      v-for="(x, indx) in question.answers"
                                      :key="indx"
                                      :value="x.displayOrder"
                                    >
                                      {{ x.displayOrder }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <!-- Answer Action - Evidence Required and Null Avalible Checkbox -->
                              <div class="row mb-4">
                                <div class="col-lg-4">
                                  {{
                                    translate(
                                      "question_component_answer_modal_label_logic_choice"
                                    )
                                  }}
                                </div>
                                <div
                                  class="col-lg-8 d-flex justify-content-start gap-2"
                                >
                                  <!-- Answer Action Required Checkbox -->
                                  <div
                                    class="form-check form-check-custom form-check-solid pe-2 border border-2 border-top-0 border-bottom-0 border-start-0"
                                    :title="
                                      translate(
                                        'question_component_answer_modal_action_checkbox_title'
                                      )
                                    "
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="`check-action-required${answer.id}`"
                                      v-model="answer.actionRequired"
                                    />
                                    <label
                                      class="form-check-label text-gray-600 user-select-none"
                                      :for="`check-action-required${answer.id}`"
                                    >
                                      {{
                                        translate(
                                          "question_component_answer_modal_action_checkbox_label"
                                        )
                                      }}
                                    </label>
                                  </div>

                                  <!-- Answer Evidence Required Checkbox -->
                                  <div
                                    class="form-check form-check-custom form-check-solid pe-2 border border-2 border-top-0 border-bottom-0 border-start-0"
                                    :title="
                                      translate(
                                        'question_component_answer_modal_evidence_checkbox_title'
                                      )
                                    "
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="`check-evidence-required${answer.id}`"
                                      v-model="answer.proofRequired"
                                    />
                                    <label
                                      class="form-check-label text-gray-600 user-select-none"
                                      :for="`check-evidence-required${answer.id}`"
                                    >
                                      {{
                                        translate(
                                          "question_component_answer_modal_evidence_checkbox_label"
                                        )
                                      }}
                                    </label>
                                  </div>

                                  <!-- Answer Null Avalible Checkbox -->
                                  <div
                                    class="form-check form-check-custom form-check-solid"
                                    v-show="!question.infoOnly"
                                    :title="
                                      translate(
                                        'question_component_modal_label_answer_nullAvailable'
                                      )
                                    "
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="`check-null-avalible${answer.id}`"
                                      v-model="answer.notScorable"
                                      @change="
                                        answer.answerValuesScore &&
                                        answer.notScorable
                                          ? (answer.answerValuesScore = false)
                                          : null
                                      "
                                    />
                                    <label
                                      class="form-check-label text-gray-600 user-select-none"
                                      :for="`check-null-avalible${answer.id}`"
                                    >
                                      {{
                                        translate(
                                          "question_component_answer_modal_na_checkbox_label"
                                        )
                                      }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <!-- Answer Evidence Required (Notes and Media) Checkbox -->
                              <div
                                v-show="answer.proofRequired"
                                class="row my-4"
                              >
                                <div class="col-lg-4"></div>
                                <div
                                  class="col-lg-8 border"
                                  style="
                                    background: #f6faff;
                                    padding: 9px;
                                    border-radius: 5px;
                                  "
                                >
                                  {{
                                    translate(
                                      "question_component_answer_modal_evidence_options_title"
                                    )
                                  }}
                                  <div class="row">
                                    <label
                                      class="form-check-label text-gray-500 user-select-none fs-7"
                                    >
                                      {{
                                        translate(
                                          "question_component_answer_modal_evidence_options_explication"
                                        )
                                      }}
                                    </label>
                                  </div>
                                  <div class="row mt-2">
                                    <div
                                      class="col-lg-8 d-flex justify-content-start gap-2"
                                    >
                                      <!-- Answer Evidence Required Notes Checkbox -->
                                      <div
                                        class="form-check form-check-custom form-check-solid form-check-sm pe-2 border border-2 border-top-0 border-bottom-0 border-start-0"
                                      >
                                        <input
                                          class="form-check-input form-check-input-sm"
                                          type="checkbox"
                                          :id="`check-notes-required${answer.id}`"
                                          v-model="answer.noteProofRequired"
                                        />
                                        <label
                                          class="form-check-label text-gray-600 user-select-none"
                                          :for="`check-notes-required${answer.id}`"
                                        >
                                          {{
                                            translate(
                                              "question_component_answer_modal_evidence_options_notes"
                                            )
                                          }}
                                        </label>
                                      </div>
                                      <!-- Answer Evidence Required Media Checkbox -->
                                      <div
                                        class="form-check form-check-custom form-check-solid form-check-sm"
                                      >
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          :id="`check-media-required${answer.id}`"
                                          v-model="answer.mediaProofRequired"
                                        />
                                        <label
                                          class="form-check-label text-gray-600 user-select-none"
                                          :for="`check-media-required${answer.id}`"
                                        >
                                          {{
                                            translate(
                                              "question_component_answer_modal_evidence_options_media"
                                            )
                                          }}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Answer Sub Option -->
                              <div v-if="answer.type !== 'Single'" class="mt-2">
                                <!-- Add Sub Options Button -->

                                <a
                                  class="btn btn-sm btn-success"
                                  @click="addSubOption(answer)"
                                >
                                  {{
                                    translate(
                                      "question_component_modal_button_add_sub_option"
                                    )
                                  }}
                                </a>

                                <div
                                  v-show="
                                    answer.answerValues.length > 0 &&
                                    answer.notScorable !== true &&
                                    !question.infoOnly
                                  "
                                  class="form-check form-check-custom form-check-solid mt-5"
                                  style="margin-left: 1.4rem !important"
                                >
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`check-score-${answer.id}`"
                                    v-model="answer.answerValuesScore"
                                  />
                                  <label
                                    class="form-check-label user-select-none text-gray-600"
                                    :for="`check-score-${answer.id}`"
                                  >
                                    {{
                                      translate(
                                        "question_component_answer_modal_checkbox_sub_option_score"
                                      )
                                    }}
                                  </label>
                                </div>

                                <ul class="p-0">
                                  <li
                                    v-for="(sub, index) in answer.answerValues"
                                    :key="sub.id"
                                    style="list-style: none"
                                  >
                                    <div
                                      :class="`d-flex ${
                                        index === 0 ? 'mt-6' : 'mt-2'
                                      }`"
                                    >
                                      <div
                                        class="col-lg-1 d-flex justify-content-center align-items-center pe-0"
                                      >
                                        <div
                                          class="sub-index-div border border-secondary"
                                        >
                                          <a class="text-gray-700">
                                            {{ index + 1 }}</a
                                          >
                                        </div>
                                      </div>
                                      <div
                                        :class="
                                          answer.answerValuesScore === false
                                            ? 'col-lg-10 pe-4'
                                            : 'col-lg-7 pe-4'
                                        "
                                      >
                                        <input
                                          type="text"
                                          v-model.trim="sub.valueText"
                                          :placeholder="
                                            translate(
                                              'question_component_modal_sub_option_input'
                                            )
                                          "
                                          class="form-control fs-6"
                                        />
                                      </div>
                                      <div
                                        :class="
                                          answer.answerValuesScore === false &&
                                          question.infoOnly === true
                                            ? 'col-lg-1 p-0'
                                            : 'col-lg-4'
                                        "
                                      >
                                        <div class="d-flex gap-4">
                                          <div
                                            v-if="
                                              answer.answerValuesScore &&
                                              !question.infoOnly
                                            "
                                          >
                                            <input
                                              :max="question.score"
                                              @blur="
                                                sub.score > question.score
                                                  ? (sub.score = question.score)
                                                  : null
                                              "
                                              onkeydown="return event.keyCode !== 69"
                                              type="number"
                                              v-model.number="sub.score"
                                              placeholder="Score"
                                              :class="`form-control  fs-6 ${
                                                sub.score > question.score
                                                  ? 'v-invalid'
                                                  : ''
                                              }`"
                                            />
                                          </div>
                                          <a
                                            class="btn btn-light-danger border border-1"
                                            style="height: 42.64px"
                                            @click="
                                              deleteSubOption(sub.id, answer)
                                            "
                                          >
                                            <i
                                              class="bi bi-trash2 fs-5 p-0"
                                            ></i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                              <div class="d-flex justify-content-end p-0">
                                <a
                                  @click="closeModal"
                                  class="btn btn-sm btn-white mt-4 border me-2"
                                  >{{ translate("Cancel") }}</a
                                >
                                <button
                                  type="submit"
                                  class="btn btn-sm btn-primary mt-4"
                                >
                                  {{ translate("Save") }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- İf Answer Type Input -->
                      <div
                        v-else
                        class="modal fade"
                        tabindex="-1"
                        :id="`answer-modal-${answer.id}`"
                        ref="newTargetModalRef"
                        aria-hidden="true"
                      >
                        <div
                          class="modal-dialog modal-dialog-centered mw-750px"
                        >
                          <div class="modal-content rounded">
                            <!-- Answer Modal Header -->
                            <div class="modal-header">
                              <h5 class="modal-title">
                                {{
                                  translate(
                                    "question_component_modal_h5_content_title"
                                  )
                                }}
                              </h5>

                              <!--begin::Close-->
                              <div
                                class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
                                @click="closeModal"
                                aria-label="Close"
                              >
                                <i class="bi bi-x-lg"></i>
                              </div>
                              <!--end::Close-->
                            </div>

                            <!-- Answer Modal Body -->
                            <div class="modal-body rounded">
                              <!-- Answer Action - Evidence Required and Null Avalible Checkbox -->
                              <div class="row mb-4">
                                <div class="col-lg-4">
                                  {{
                                    translate(
                                      "question_component_answer_modal_label_logic_choice"
                                    )
                                  }}
                                </div>
                                <div
                                  class="col-lg-8 d-flex justify-content-start gap-2"
                                >
                                  <!-- Answer Action Required Checkbox -->
                                  <div
                                    class="form-check form-check-custom form-check-solid pe-2 border border-end-2 border-top-0 border-bottom-0 border-start-0"
                                    :title="
                                      translate(
                                        'question_component_answer_modal_action_checkbox_title'
                                      )
                                    "
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="`check-action-required${answer.id}`"
                                      v-model="answer.actionRequired"
                                    />
                                    <label
                                      class="form-check-label text-gray-600 user-select-none"
                                      :for="`check-action-required${answer.id}`"
                                    >
                                      {{
                                        translate(
                                          "question_component_answer_modal_action_checkbox_label"
                                        )
                                      }}
                                    </label>
                                  </div>

                                  <!-- Answer Evidence Required Checkbox -->
                                  <div
                                    class="form-check form-check-custom form-check-solid pe-2 border border-2 border-top-0 border-bottom-0 border-start-0"
                                    :title="
                                      translate(
                                        'question_component_answer_modal_evidence_checkbox_title'
                                      )
                                    "
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="`check-evidence-required${answer.id}`"
                                      v-model="answer.proofRequired"
                                    />
                                    <label
                                      class="form-check-label text-gray-600 user-select-none"
                                      :for="`check-evidence-required${answer.id}`"
                                    >
                                      {{
                                        translate(
                                          "question_component_answer_modal_evidence_checkbox_label"
                                        )
                                      }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <!-- Answer Evidence Required (Notes and Media) Checkbox -->
                              <div
                                v-show="answer.proofRequired"
                                class="row my-4"
                              >
                                <div class="col-lg-4"></div>
                                <div
                                  class="col-lg-8 border"
                                  style="
                                    background: #f6faff;
                                    padding: 9px;
                                    border-radius: 5px;
                                  "
                                >
                                  {{
                                    translate(
                                      "question_component_answer_modal_evidence_options_title"
                                    )
                                  }}
                                  <div class="row">
                                    <label
                                      class="form-check-label text-gray-500 user-select-none fs-7"
                                    >
                                      {{
                                        translate(
                                          "question_component_answer_modal_evidence_options_explication"
                                        )
                                      }}
                                    </label>
                                  </div>
                                  <div class="row mt-2">
                                    <div
                                      class="col-lg-8 d-flex justify-content-start gap-2"
                                    >
                                      <!-- Answer Evidence Required Notes Checkbox -->
                                      <div
                                        class="form-check form-check-custom form-check-solid form-check-sm pe-2 border border-2 border-top-0 border-bottom-0 border-start-0"
                                      >
                                        <input
                                          class="form-check-input form-check-input-sm"
                                          type="checkbox"
                                          :id="`check-notes-required${answer.id}`"
                                          v-model="answer.noteProofRequired"
                                        />
                                        <label
                                          class="form-check-label text-gray-600 user-select-none"
                                          :for="`check-notes-required${answer.id}`"
                                        >
                                          {{
                                            translate(
                                              "question_component_answer_modal_evidence_options_notes"
                                            )
                                          }}
                                        </label>
                                      </div>
                                      <!-- Answer Evidence Required Media Checkbox -->
                                      <div
                                        class="form-check form-check-custom form-check-solid form-check-sm"
                                      >
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          :id="`check-media-required${answer.id}`"
                                          v-model="answer.mediaProofRequired"
                                        />
                                        <label
                                          class="form-check-label text-gray-600 user-select-none"
                                          :for="`check-media-required${answer.id}`"
                                        >
                                          {{
                                            translate(
                                              "question_component_answer_modal_evidence_options_media"
                                            )
                                          }}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="d-flex justify-content-end p-0">
                                <a
                                  @click="closeModal"
                                  class="btn btn-sm btn-white mt-4 border me-2"
                                  >{{ translate("Cancel") }}</a
                                >
                                <a
                                  class="btn btn-sm btn-primary mt-4"
                                  @click="saveAnswerTypeInput(answer)"
                                >
                                  {{ translate("Save") }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Answer Modal End -->
                    </Form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Select Answer Type and Answers End-->

            <!-- Question Button Set  Start-->
            <div class="d-flex justify-content-end p-0">
              <a
                class="btn btn-sm btn-white border me-2"
                @click="deleteQuestion($event, question.id)"
              >
                {{ translate("Delete") }}
              </a>
              <button type="submit" class="btn btn-sm btn-primary">
                {{ translate("Confirm") }}
              </button>
            </div>
            <!-- Question Button Set End-->
          </Form>
        </div>
      </div>
    </transition-group>

    <TemplateList v-if="listActive" @closeList="closeTemplateList" />

    <div
      class="modal fade"
      tabindex="-1"
      id="add-template-modal"
      ref="templateModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-650px">
        <div class="modal-content rounded">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ translate("question_comp_save_template_modal_title") }}
            </h5>

            <!--begin::Close-->
            <div
              class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="bi bi-x-lg"></i>
            </div>
            <!--end::Close-->
          </div>

          <div class="modal-body rounded p-0">
            <Form
              ref="templateForm"
              v-slot="{ errors }"
              class="form p-10 rounded-bottom"
              novalidate="novalidate"
              @submit="onSubmitTamplate"
              :validation-schema="templateValidator"
              style="padding-bottom: 1.5rem !important; background: #fbfbfb"
            >
              <div class="row mt-5">
                <label class="col-lg-4 col-form-label fw-bold fs-6 required">{{
                  translate("question_comp_save_template_modal_label_name")
                }}</label>

                <div class="col-lg-8 fv-row d-v-container">
                  <div class="fv-plugins-message-container d-v-s-content">
                    <div class="fv-help-block ms-2 v-element">
                      <ErrorMessage name="name" />
                    </div>
                  </div>
                  <Field
                    type="text"
                    name="name"
                    class="form-control fs-6"
                    :class="errors['name'] !== undefined ? 'v-invalid' : ''"
                    :placeholder="
                      translate('question_comp_save_template_modal_label_name')
                    "
                  />
                </div>
              </div>

              <div
                class="d-flex justify-content-end p-0"
                style="padding-top: 1.5rem !important"
              >
                <button
                  type="reset"
                  class="btn btn-white btn-active-light me-2 border btn-sm fs-6"
                  data-bs-dismiss="modal"
                >
                  {{ translate("Cancel") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-primary border btn-sm fs-6"
                >
                  <span class="indicator-label">
                    {{ translate("Save") }}
                  </span>
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
    <!-- Question Item End -->
  </div>
</template>

<script setup>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import CategoryModule from "@/store/modules/Templates/AdminTemplateCategoryModule";
import TemplateList from "@/components/Audit/QuestionTemplate/TemplateList.vue";
import { hideModal } from "@/core/helpers/dom";
import { useConfirm } from "primevue/useconfirm";
import { ref, computed, onBeforeUpdate, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { onBeforeRouteLeave, useRouter } from "vue-router";
import {
  saveTemplate,
  getTemplate,
  returnChekedTemplate,
  isThereRecord,
} from "@/store/utils/templateService";
import * as Yup from "yup";

const store = useStore();
const platform = store.state.platform;
const router = useRouter();
const description = ref(true);
const loading = ref(false);

store.dispatch("AdminTemplateAnswersTempalteModule/GET_ALL_ANSWERS_TEMPLATE", {
  page: 1,
  pageSize: 1000,
});

const answersTemplates = computed(
  () =>
    store.getters["AdminTemplateAnswersTempalteModule/_getAnswerTemplateList"]
);
const dynamicAnswerTemplateList = ref({});
const addAnswerTemplate = (question) => {
  dynamicAnswerTemplateList.value[`list${question.id}`].forEach(
    (answerTemplate) => {
      let answerButton = {
        id:
          answerTemplate.type +
          "-" +
          new Date().getTime() +
          `${answerTemplate.id}`,
        answerText: answerTemplate.answerText,
        score: 0,
        displayOrder: question.answers.length + 1,
        notScorable: answerTemplate.notScorable,
        type: answerTemplate.type,
        answerValues: [],
        answerValuesScore: false,
        answerTemplateId: answerTemplate.id,
        actionRequired: answerTemplate.actionRequired,
        proofRequired: false,
        noteProofRequired: answerTemplate.noteProofRequired,
        mediaProofRequired: answerTemplate.mediaProofRequired,
      };

      if (
        answerTemplate.noteProofRequired ||
        answerTemplate.mediaProofRequired
      ) {
        answerButton.proofRequired = true;
      }
      replaceAnswerFound(question.id);
      question.answers.push(answerButton);
    }
  );
  dynamicAnswerTemplateList.value[`list${question.id}`] = [];
};

// ! Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
// ! Confirm Message
const confirm = useConfirm();

// ! Get Category
const categoryList = ref([]);
CategoryModule.actions.GET_COMMON_CATEGORY().then((response) => {
  if (response.length > 0) {
    categoryList.value = response;
  }
});

// Validation Tanımlaması

const questionValidator = Yup.object().shape({
  title: Yup.string()
    .nullable()
    .required(translate("question_component_validation_question_text")),
});

const answerValidator = Yup.object().shape({
  answerTitle: Yup.string()
    .nullable()
    .required(translate("question_component_validation_answer_text")),
});

// ! Qustion List Items
const questionList = ref([]);
const checkedQuestionCount = computed(
  () => questionList.value.filter((i) => i.checked === true).length
);

const addQuestion = () => {
  let question = {
    id: new Date().getTime(),
    categoryId: 0,
    questionText: null,
    questionInfoText: null,
    code: null,
    score: 0,
    infoOnly: false,
    answers: [],
    checked: false,
    isRequired: false,
  };
  if (returnChekedTemplate() !== false) {
    question = returnChekedTemplate();
    question.id = new Date().getTime();
  }

  questionList.value.push(question);

  dynamicAnswerTemplateList.value[`list${question.id}`] = [];
};

const deleteQuestion = (event, questionId) => {
  confirm.require({
    target: event.currentTarget,
    message: translate("question_component_delete_question_confirm_message"),
    icon: "bi bi-exclamation-lg",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-light-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      questionList.value = questionList.value.filter(
        (item) => item.id !== questionId
      );
      delete dynamicAnswerTemplateList.value[`list${questionId}`];
    },
    reject: () => {
      return;
    },
  });
};

const postQuestionList = () => {
  loading.value = true;
  let postObject = {
    templateQuestions: [],
  };

  questionList.value.forEach((item) => {
    if (item.checked) {
      let question = {
        id: 0,
        templateCategoryId: 0,
        questionText: null,
        questionInfoText: null,
        code: null,
        score: 0,
        infoOnly: false,
        answers: [],
        isRequired: false,
      };

      if (!item.infoOnly) {
        question.templateCategoryId = item.categoryId;
        question.score =
          item.score === null || item.score === "" ? 0 : item.score;
      }
      question.questionText = item.questionText;
      question.questionInfoText = item.questionInfoText;
      question.code = item.code;
      question.infoOnly = item.infoOnly;
      question.answers = [];
      question.isRequired = item.isRequired;

      item.answers.forEach((answer) => {
        let answerButton = {
          id: 0,
          answerText: null,
          score: null,
          displayOrder: 0,
          notScorable: false,
          type: null,
          templateAnswerTemplateId: 0,
          answerValues: [],
          actionRequired: false,
          noteProofRequired: false,
          mediaProofRequired: false,
        };

        if (!question.infoOnly && !answer.notScorable) {
          answerButton.score = answer.score =
            answer.score === null || answer.score === "" ? 0 : answer.score;
        }
        answerButton.notScorable = answer.notScorable;
        answerButton.answerText = answer.answerText;
        answerButton.displayOrder = answer.displayOrder;
        answerButton.type = answer.type;
        answerButton.templateAnswerTemplateId = answer.answerTemplateId;
        answerButton.actionRequired = answer.actionRequired;
        answerButton.noteProofRequired = answer.noteProofRequired;
        answerButton.mediaProofRequired = answer.mediaProofRequired;

        if (!answerTypeController2(answer.type)) {
          answer.answerValues.forEach((answerValue) => {
            let subOptions = {
              id: 0,
              templateAnswerId: 0,
              valueText: null,
              score: null,
            };
            subOptions.valueText = answerValue.valueText;
            if (
              !question.infoOnly &&
              !answer.notScorable &&
              answer.answerValuesScore
            ) {
              subOptions.score =
                answerValue.score === null || answerValue.score === ""
                  ? 0
                  : answerValue.score;
              if (answerValue.score === null && answer.answerValuesScore) {
                subOptions.score = answer.score;
              }
            }
            answerButton.answerValues.push(subOptions);
          });
        }

        question.answers.push(answerButton);
      });

      postObject.templateQuestions.push(question);
    }
  });

  store
    .dispatch("AdminTemplateQuestionModule/ADD_QUESTIONS", postObject)
    .then((response) => {
      if (response) {
        questionList.value = questionList.value.filter(
          (i) => i.checked !== true
        );
        loading.value = false;
      }
    });
};

// ! Question Transactions

let lastMenuId = ref(null);
let controllerAnswer = ref(true);
let notAnswerFound = ref([]);

const controlerAnswerFound = (questionId) => {
  let status = false;
  status = notAnswerFound.value.some((id) => id === questionId);
  return status;
};
const replaceAnswerFound = (questionId) => {
  notAnswerFound.value = notAnswerFound.value.filter((id) => id !== questionId);
};

const confirmQuestion = (question) => {
  if (question.answers.length > 0) {
    controllerAnswer.value = true;
    question.answers.forEach((i) => {
      if (
        (i.answerText === null || i.answerText === "") &&
        !answerTypeController2(i.type)
      ) {
        i.answerText = "";
        controllerAnswer.value = false;
      }
    });

    if (controllerAnswer.value) {
      if (question.infoOnly) {
        question.categoryId = 0;
        question.score = 0;
        question.answers.forEach((i) => {
          i.score = null;
          i.answerValues.forEach((x) => (x.score = null));
        });
      }
      question.checked = true;
    }
  } else {
    notAnswerFound.value.push(question.id);
  }
};

const answerMenuShow = (id) => {
  lastMenuId.value = lastMenuId.value !== id ? id : null;
};

const answerOptions = ref([
  { type: "Single", icon: "bi bi-app", color: "#fd7e14" },
  { type: "Radio", icon: "bi bi-ui-radios-grid", color: "#fd7e14" },
  { type: "Multiple", icon: "bi bi-check2-square", color: "#fd7e14" },
  { type: "Text", icon: "bi bi-fonts", color: "#214cc5" },
  { type: "DateTime", icon: "bi bi-calendar", color: "#214cc5" },
  { type: "Phone", icon: "bi bi-telephone", color: "#214cc5" },
  { type: "Signature", icon: "bi bi-pencil-square", color: "#214cc5" },
  { type: "Location", icon: "bi bi-geo-alt", color: "#214cc5" },
]);

// ! Answer Transactions
const selectedAnswer = ref(null);
let lastDisplayOrder = 0;
let lastAnswerValue = {
  id: 0,
  answerText: null,
  score: 0,
  displayOrder: 0,
  notScorable: false,
  type: null,
  answerValues: [],
  answerValuesScore: false,
  actionRequired: false,
  proofRequired: false,
  noteProofRequired: false,
  mediaProofRequired: false,
};

const saveAnswer = (question, answer) => {
  if (answer.answerText !== null && answer.answerText !== "") {
    if (answer.notScorable || !answer.answerValuesScore) {
      if (answer.notScorable) {
        answer.score = null;
      }
      answer.answerValues.forEach((value) => (value.score = null));
    }

    if (!answer.proofRequired) {
      answer.mediaProofRequired = false;
      answer.noteProofRequired = false;
    }
    if (!answer.mediaProofRequired && !answer.noteProofRequired) {
      answer.proofRequired = false;
    }
    if (answer.answerValues.length > 0) {
      answer.answerValues.forEach((x) => {
        if (x.valueText === "" || x.valueText === null) {
          answer.answerValues = answer.answerValues.filter(
            (i) => i.id !== x.id
          );
        }
      });
    }
  }
  answerSaved.value = true;
  hideModalFunction();
};
const saveAnswerTypeInput = (answer) => {
  if (!answer.proofRequired) {
    answer.mediaProofRequired = false;
    answer.noteProofRequired = false;
  }
  if (!answer.mediaProofRequired && !answer.noteProofRequired) {
    answer.proofRequired = false;
  }
  answerSaved.value = true;
  hideModalFunction();
};

const addAnswer = (answerType, question) => {
  let answerButton = {
    id: answerType + "-" + new Date().getTime(),
    answerText: null,
    score: 0,
    displayOrder: question.answers.length + 1,
    notScorable: false,
    type: answerType,
    answerValues: [],
    answerValuesScore: false,
    answerTemplateId: 0,
    actionRequired: false,
    proofRequired: false,
    noteProofRequired: false,
    mediaProofRequired: false,
  };

  if (
    answerType === "Text" ||
    answerType === "DateTime" ||
    answerType === "Phone" ||
    answerType === "Signature" ||
    answerType === "Location"
  ) {
    question.answers = [];
    question.score = 0;
  }
  replaceAnswerFound(question.id);
  question.answers.push(answerButton);
  answerMenuShow(question.id);
};

const deleteAnswer = (id, question) => {
  document
    .getElementById(`answer-modal-${id}`)
    .removeEventListener("hide.bs.modal", answerModalClose);
  question.answers = question.answers.filter((item) => item.id !== id);
};

const displayChange = (question, answer) => {
  question.answers.forEach((item) => {
    if (item.id !== answer.id) {
      if (item.displayOrder === answer.displayOrder) {
        item.displayOrder = lastDisplayOrder;
      }
    }
  });
  lastDisplayOrder = answer.displayOrder;
  question.answers = question.answers.sort(
    (a, b) => parseInt(a.displayOrder) - parseInt(b.displayOrder)
  );
};

let typeList = ["Text", "DateTime", "Phone", "Signature", "Location"];
const answerTypeController = (questionAnswers) => {
  let status = false;

  for (let index = 0; index < questionAnswers.length; index++) {
    let answer = questionAnswers[index];
    if (!status) {
      status = typeList.some((x) => x === answer.type);
    } else break;
  }

  return status;
};

const answerTypeController2 = (type) => {
  let status = false;
  status = typeList.some((x) => x === type);
  return status;
};

// ! Sub Options Transactions
const addSubOption = (answer) => {
  let subOptions = {
    id: "sub-" + new Date().getTime(),
    answerId: 0,
    valueText: null,
    score: null,
  };

  answer.answerValues.push(subOptions);
};
const deleteSubOption = (id, answer) => {
  answer.answerValues = answer.answerValues.filter((item) => item.id !== id);
};

// ! Answer Modal Transactions
const answerSaved = ref(false);
const addEventModal = (answer) => {
  Object.keys(lastAnswerValue).forEach((key) => {
    if (key === "answerValues") {
      lastAnswerValue.answerValues = [];
      if (answer.answerValues.length > 0) {
        answer.answerValues.forEach((subAnswer) => {
          let x = new Object();
          x.id = subAnswer.id;
          x.answerId = 0;
          x.valueText = subAnswer.valueText;
          x.score = subAnswer.score;
          lastAnswerValue.answerValues.push(x);
        });
      }
    } else {
      lastAnswerValue[key] = answer[key];
    }
  });
  selectedAnswer.value = answer;
  lastDisplayOrder = answer.displayOrder;
  document
    .getElementById(`answer-modal-${answer.id}`)
    .removeEventListener("hide.bs.modal", answerModalClose);
  document
    .getElementById(`answer-modal-${answer.id}`)
    .addEventListener("hide.bs.modal", answerModalClose);
};
const closeModal = () => {
  answerSaved.value = false;
  hideModalFunction();
};
const hideModalFunction = () => {
  let modal = document.querySelector(
    `#answer-modal-${selectedAnswer.value.id}`
  );
  hideModal(modal);
};

// ! Answer Modal Close Event
const answerModalClose = () => {
  setTimeout(() => {
    if (!answerSaved.value) {
      selectedAnswer.value.answerText = lastAnswerValue.answerText;
      selectedAnswer.value.score = lastAnswerValue.score;
      selectedAnswer.value.notScorable = lastAnswerValue.notScorable;
      selectedAnswer.value.answerValues = lastAnswerValue.answerValues;
      selectedAnswer.value.answerValuesScore =
        lastAnswerValue.answerValuesScore;
      selectedAnswer.value.actionRequired = lastAnswerValue.actionRequired;
      selectedAnswer.value.proofRequired = lastAnswerValue.proofRequired;
    }
  }, 500);
};

// ! Answer Menu Close
const questionDivClick = (event) => {
  let answerMenu = document.querySelector(
    `#btn-answer-list-${lastMenuId.value}`
  );
  if (!event.composedPath().includes(answerMenu)) {
    lastMenuId.value = null;
  }
};

// ! Question Type Info ?

const changeQuestionInfoStatus = (event, question) => {
  question.infoOnly
    ? question.answers.forEach((item) => (item.answerValuesScore = false))
    : "";

  question.answers = [];
};

// ! Template List
const howTemplate = ref(false);
const listActive = ref(false);
const templateModal = ref(null);
const templateForm = ref(null);
const selectedTemplateQuestion = ref(null);
const templateValidator = Yup.object().shape({
  name: Yup.string().required(
    translate("question_comp_save_template_modal_form_name_valid")
  ),
});

const closeTemplateList = () => {
  howTemplate.value = isThereRecord();
  listActive.value = false;
};
const selectTemplate = (question) => {
  selectedTemplateQuestion.value = question;
};
const onSubmitTamplate = (values) => {
  let templates = getTemplate();

  let templateArray = [];
  let object = {
    name: values.name,
    id: new Date().getTime(),
    checked: false,
    question: selectedTemplateQuestion.value,
  };
  if (templates === null) {
    templateArray.push(object);
    saveTemplate(JSON.stringify(templateArray));
  } else {
    let x = JSON.parse(templates);
    x.push(object);
    saveTemplate(JSON.stringify(x));
  }
  howTemplate.value = isThereRecord();
  templateForm.value.resetForm();
  hideModal(templateModal.value);
};

addQuestion();

watch(locale, () => {
  setCurrentPageBreadcrumbs(translate("question_component_breadcrumbs_new"), [
    translate("question_component_breadcrumbs"),
  ]);
});

onMounted(() => {
  howTemplate.value = isThereRecord();
  setCurrentPageBreadcrumbs(translate("question_component_breadcrumbs_new"), [
    translate("question_component_breadcrumbs"),
  ]);
});

const firstData = JSON.stringify(questionList.value);
onBeforeRouteLeave((to, from, next) => {
  if (questionList.value.length > 0) {
    let status = true;
    if (firstData !== JSON.stringify(questionList.value)) {
      status = false;
    }

    if (!status) {
      confirm.require({
        group: "exitPage",
        message: translate("confirm_exit_page"),
        header: "Confirmation",
        icon: "bi bi-exclamation-lg",
        acceptLabel: translate("customer_location_confirm_acceptLabel"),
        rejectLabel: translate("customer_location_confirm_rejectLabel"),
        acceptClass: "btn btn-sm btn-light-primary",
        rejectClass: "btn btn-sm btn-light",
        accept: () => {
          next(true);
        },
        reject: () => {
          next(false);
        },
      });
    } else {
      next(true);
    }
  } else {
    next(true);
  }
});
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  visibility: hidden;
}
.answer-list {
  position: absolute;
  top: 40px;
  padding: 0;
  z-index: 5;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #dbdbdb;
}

.answer-list li {
  box-sizing: border-box;
  min-width: 240px;
  list-style: none;
  background-color: #fff;
  color: #838383;
  padding: 12px 7px 12px 7px;
  text-align: start;
  cursor: pointer;
  border-top: 1px solid #f5f5f5;
}
.answer-list li:hover {
  background-color: #ececec;
  color: #323232;
}
.answer-list > :first-child li {
  border-top: none;
  border-radius: 5px 5px 0 0;
}
.answer-list > :last-child li {
  border-radius: 0 0 5px 5px;
}

.qx-answer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.13);
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 10000;
  overflow: auto;
}

.sub-index-div {
  width: 2rem;
  height: 2rem;
  background: #fff;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 50%;
  font-weight: 300;
}
.ques-index-div {
  width: 2rem;
  height: 2rem;
  background: #ff5e00d3;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 50%;
  font-weight: 400;
  border: 1px solid #e5e4e4;
  position: absolute;
  top: 61px;
  left: -12px;
}
.d-v-s-content {
  padding: 0px 0px 16px 14px;
  position: absolute;
  bottom: 1px;
  left: 3px;
}
.confim-div {
  width: 2rem;
  height: 2rem;
  background: #21c338;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 50%;
  font-weight: 400;
  border: 1px solid #e5e4e4;
  position: absolute;
  top: 17px;
  left: -12px;
}
</style>
